module.exports = "/_next/static/resources/cdf-wide-3876904ac6c80307c0fde36884675c97.png";